module.exports = __webpack_public_path__ + "img/IMG_1699_FoamcoreMatted.5771f133.jpg";